<hyperkit-dialog class="hyperkit-component" headerText="Delete User">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <hyperkit-typography variant="body" size="md" align="left" color="body">
          Are you sure you want to permanently remove
          <strong>{{ user.firstName }} {{ user.lastName }}</strong> from the
          Portal?</hyperkit-typography
        >
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Delete"
          (click)="onDelete()"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
